import { Link } from "react-router-dom";

const pageListStyle = {
  padding: "40px",
  fontFamily: "'Raleway', sans-serif",
  maxWidth: "600px",
};

const linkItemStyle = {
  display: "block",
  padding: "12px 16px",
  marginBottom: "8px",
  background: "#f5f5f5",
  borderRadius: "8px",
  color: "#3c5359",
  textDecoration: "none",
  fontSize: "15px",
};

const MockupIndex = () => {
  const pages = [
    { to: "/onboarding", label: "Onboarding — pirmas prisijungimas" },
    { to: "/dashboard", label: "Dashboard — pagrindinis langas (8 kl., Horizontai)" },
    { to: "/challenge", label: "Challenge — naujas iššūkis pagal temą ir lygį" },
  ];

  return (
    <div style={pageListStyle}>
      <h1>Mockups</h1>
      <p style={{ color: "#768689", marginBottom: "24px" }}>
        Standalone UI pages — no auth, no API.
      </p>
      {pages.length === 0 ? (
        <p style={{ color: "#999" }}>No mockup pages yet. Add them to this index.</p>
      ) : (
        pages.map((page) => (
          <Link key={page.to} to={page.to} style={linkItemStyle}>
            {page.label}
          </Link>
        ))
      )}
    </div>
  );
};

export default MockupIndex;
